<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Delete Incident - ' + incident.IncidentId + ' :: MeritEHS'" />

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                        <router-link :to="`/incidents`">
                            <i class="fa fa-stethoscope"></i> Incidents
                        </router-link>
                    </li>
                    <li class="breadcrumb-item d-block d-md-inline-block mt-md-0 mt-2">
                        <router-link :to="`/incidents/view/${incident.IncidentId}`">
                            <incident-name :incident="incident" />
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                        <i class="fa fa-trash"></i> Delete
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-4 col-lg-6">
                    <div class="alert alert-danger">
                        <strong>Warning:</strong> You are about to delete this incident and all of its data. This change <strong>cannot be undone.</strong>
                    </div>

                    <b-button variant="danger" v-on:click="deleteIncident()" :disabled="saving">
                        <template v-if="saving">
                            Deleting...
                        </template>
                        <template v-else>
                            <i class="fa fa-trash"></i> Delete Incident
                        </template>
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                incident_id: this.$route.params.id,
                incident: {},
            }
        },

        methods: {

            getIncident: function() {
                //Get the data
                this.$http
                    .get('incident/view/' + this.incident_id)
                    .then(response => {
                        //Set all the data
                        this.incident = response.data.incident;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            deleteIncident: function() {
                //SHow loading
                this.saving = true;

                //Send it
                this.$http
                .post('incident/delete/' + this.incident_id)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Incident Deleted');

                    //Return to main list?
                    this.$router.push('/incidents');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {

                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },
        mounted() {
            //Get the incident
            this.getIncident();
        }
    }
</script>
